<template>
<!-- 개인정보 수집 및 이용 팝업 -->
<transition name="modal" appear>
    <div class="modal modal-overlay">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div>
                        <p class="bold dp-inblock h-30px font-23 mb-30">개인정보 수집 및 이용</p>
                        <a class="float-right layer-close ml-10 pointer" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                            <img src="../assets/img/close.png" alt="close" class="close-btn">
                        </a>

                        <div class="agree-box">
                            <p name="" id="" class="w-100per h-300px">1. 개인정보의 수집 및 이용 목적 <br>
                                캐럿글로벌은 수집한 개인정보를 다음의 목적을 위해 활용합니다. <br>
                                ο 문의접수와 처리, 회신 <br> <br>

                                2. 수집하는 개인정보의 항목 <br>
                                캐럿글로벌은 문의접수와 처리, 회신을 위해 아래와 같은 개인정보를 수집하고 있습니다. <br>
                                가. 수집하는 개인정보 항목 <br>
                                ο 이름, E-mail, 연락처 <br>
                                나. 수집방법 <br>
                                1) 홈페이지를 통한 1:1 문의 <br>
                                2) 이용자 쿠키정보 활용 <br> <br>

                                3. 수집한 개인정보의 보유 및 이용기간 <br>
                                개인정보의 보유 및 이용기간은 다음과 같습니다. <br>
                                ο 보유항목: 수집항목과 같습니다. <br>
                                ο 보유근거: 이용약관 및 개인정보취급방침 <br>
                                ο 보유기간: 문의접수 후 1년간 보관 <br>
                                4. 귀하는 위와 같은 개인정보 수집 및 이용에 동의하지 않을 수 있으며, 동의하지 않을 시 문의하기 서비스가 제한될 수 있습니다.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer txt-center">
                    <a class="admin-btn-default btn ml-05 pointer" @click="$emit('close')" data-dismiss="modal" aria-label="Close">확인</a>
                </div>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.modal {
    &.modal-overlay {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 30;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }

    &-window {
        border-radius: 4px;
        overflow: hidden;
    }

    &-content {
        padding: 10px 20px;
    }
}

.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.4s;

    .modal-window {
        transition: opacity 0.4s, transform 0.4s;
    }
}

.modal-leave-active {
    transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;

    .modal-window {
        opacity: 0;
        transform: translateY(-20px);
    }
}
</style>
